<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<div class="copyright">
<p class="center ">First Mariner Books edition 2014</p>
<p class="center spaceabove1">Copyright © 2013 by Peter Rock</p>
<p class="center spaceabove1">All rights reserved</p>
<p class="center spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="center spaceabove1"><a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a></p>
<p class="center spaceabove1"><em>The Library of Congress has cataloged the print edition as follows:</em></p>
<p class="center ">Rock, Peter, date.</p>
<p class="center ">The Shelter Cycle / Peter Rock.</p>
<p class="center ">pages cm</p>
<p class="center ">ISBN 978-0-547-85908-8    ISBN 978-0-544-28963-5 (pbk.)</p>
<p class="center ">1. Church Universal and Triumphant—Fiction. 2. Children—Montana—Fiction. 3. Self-realization—Fiction. I. Title.</p>
<p class="center "><span class="smallcaps">PS</span>3568.<span class="smallcaps">O</span>327<span class="smallcaps">S</span>54 2013</p>
<p class="center ">813'.54—dc23 2012040363</p>
<p class="center spaceabove1">eISBN 978-0-547-85911-8<br/>
v3.0421</p>
<p class="center spaceabove1">An excerpt of this book originally appeared in <em>Tin House.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?7da8016e